export default __webpack_public_path__ + "js_images/42dc142c.png";